import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
// import MainUnity from './main_unity'
import { Link } from 'react-router-dom';
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import { PrismLight as SyntaxHighlighter } from 'react-syntax-highlighter';
import csharp from 'react-syntax-highlighter/dist/esm/languages/prism/csharp';
import DictsInfo from '../../components/dicts_info.jsx'

SyntaxHighlighter.registerLanguage('csharp', csharp);

function refreshPage(){
  setTimeout(()=>{
    window.location.reload(false);
  }, 500);
 
}


export default class MembuatGameObjectBerputarUnity3D extends Component {
  render() {
    const MembuatGameobjectberputarunity3D = `using System.Collections;    \nusing System.Collections.Generic;    \nusing UnityEngine;  
    \npublic class Script_object_berputar : MonoBehaviour \n{
      // Start is called before the first frame update
      void Start()
      {
                  
      }

      // Update is called once per frame
      void Update()
      {
        transform.Rotate(new Vector3(0.0f, 0.0f, 5f));
      }    \n}`
    
    return (
      <div>

      <Helmet>
        <title>Membuat Game Object Berputar Pada Unity 3D </title>
        <meta name="description" content="cara membuat object berputar unity 3d, cara membuat game dengan unity 3d untuk pemula, tutorial unity 3d untuk pemula, unity 3d" />
        <link rel="canonical" href="https://dictionaryplusplus.my.id/unity-3D/membuat-game-object-berputar-unity-3D"></link>
      </Helmet>      
        
        {/* <HeadingUnity/> */}
        
        <section className="colorlib-about">
          <div className="colorlib-narrow-content">
          
            <div className="row">
            
              {/* <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInBottom"> */}
              <div className="col-md-9 col-md-offset-0 col-md-pull-0" >
              
              
                  
                <h1 style={{fontSize: '1.5rem'}} className="colorlib-heading">Membuat Game Object Berputar Pada Unity 3D</h1>

                <p>Pada pembahasan kali ini kita akan membuat menjadi dapat berputar.</p>
                <p>Gak perlu banyak basi basi,</p>
                <p></p>
                <p></p>
                <p></p>
                
                

                <strong><p>Caranya seperti ini:</p></strong>

                <SyntaxHighlighter language="csharp" style={dark} showLineNumbers={true} wrapLines={true}>
                  {MembuatGameobjectberputarunity3D}
                </SyntaxHighlighter>


                <br/>
                <span>Baca juga:</span>
                <br/>
                <span>tutorial lengkap cara menggunakan unity <Link to="/unity-3D" className="nav-link" onClick={refreshPage}>disini</Link></span>
                <br/>
                <br/>
                
                

                <strong><p>Selamat mencoba..</p></strong>
              
              </div>
              <DictsInfo/>
            </div>

            {/* <div className="row row-pt-md"></div> */}

          </div>
        </section>
        {/* <MainUnity/> */}
      </div>
    )
  }
}